<!-- src/views/NotFoundPage.vue -->
<template>
  <!-- Pantalla completa, centrada -->
  <v-container
    fluid
    class="not-found d-flex flex-column align-center justify-center text-center"
  >
    <!-- 404 grande -->
    <h1 class="error-code">404</h1>

    <!-- “Page N ot Found” con la N como imagen -->
    <div
      class="error-title d-flex align-center justify-center flex-wrap"
    >
      <span>Page&nbsp;</span>

      <!-- Sustituye src por tu imagen -->
      <v-img
        src="../../../assets/newlanding/Landing/pulso-amarillo.png"
        alt="N"
        class="tilde-img mx-1"
        contain
      ></v-img>

      <span>ot&nbsp;Found</span>
    </div>

    <!-- Sub-mensaje -->
    <p class="error-subtitle mt-6">
      ¡Ups! Parece que la página que buscabas no existe.
    </p>

    <!-- Botón de regreso -->
    <v-btn
      class="back-btn mt-10"
      large
      rounded
      @click="$router.push('/')"
    >
      Volver a Konecta.
    </v-btn>
  </v-container>
</template>

<script setup>
defineOptions({ name: 'NotFoundPage' });
</script>

<style scoped lang="scss">
/* Color de fondo principal */
.not-found {
  background-color: #1300d4; /* ajusta si tu branding usa otro púrpura */
  min-height: 100vh;
  padding: 24px;
}

/* 404 */
.error-code {
  font-size: clamp(4.5rem, 15vw, 10rem);
  font-weight: 700;
  color: #ffffff;
  margin: 0;
}

/* “Page N ot Found” */
.error-title {
  font-size: clamp(2rem, 8vw, 6rem);
  font-weight: 700;
  color: #ffffff;
  line-height: 1.1;
}

/* Imagen de la N */
.tilde-img {
  width: 120px;
  display: inline-block;
}

@media (max-width: 1200px) {
  .tilde-img {
    width: 90px;
  }
}

@media (max-width: 700px) {
  .tilde-img {
    width: 70px;
  }
}

@media (max-width: 450px) {
  .tilde-img {
    width: 50px;
  }
}

@media (max-width: 350px) {
  .tilde-img {
    width: 35px;
  }
}

/* Mensaje descriptivo */
.error-subtitle {
  font-size: clamp(1rem, 4vw, 1.5rem);
  font-weight: 400;
  color: #ffffff;
  max-width: 640px;
  margin: 0;
}

/* Botón */
.back-btn {
  text-transform: none;
  background-color: #ffffff !important;
  color: #1300d4 !important;
  font-weight: 500;
  min-width: 240px;
  font-family: "Poppins", "Barlow", sans-serif !important;
}
</style>
